// extracted by mini-css-extract-plugin
export default {"root":"CellLoadingController_root__-+RgR","placeHolderShimmer":"CellLoadingController_placeHolderShimmer__jmXBv"};